var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "none",
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#334443",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.19 2.733 2.129 4.258c.29.593 1.064 1.162 1.718 1.27l3.859.642c2.468.411 3.049 2.202 1.27 3.968l-3 3c-.508.508-.787 1.488-.63 2.19l.86 3.714c.677 2.94-.883 4.077-3.485 2.54l-3.617-2.14c-.653-.388-1.73-.388-2.395 0l-3.617 2.14c-2.59 1.537-4.162.388-3.485-2.54l.86-3.714c.157-.702-.122-1.682-.63-2.19l-3-3C.261 11.105.829 9.314 3.297 8.903l3.86-.641c.64-.11 1.415-.678 1.705-1.27l2.13-4.259c1.16-2.31 3.048-2.31 4.197 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.ae46613781fdd0c6a5852a3ce4b1c065.svg";
export { ForwardRef as ReactComponent };